import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";

export const EBAY_URL = "https://www.ebay.de/str/prozenthaus";

const LINKS = [
  { id: "about", label: "Über uns", testId: TESTIDS.navLinkAbout },
  { id: "categories", label: "Kategorien", testId: TESTIDS.navLinkCategories },
  { id: "ebay", label: "eBay-Shop", testId: TESTIDS.navLinkEbay },
  { id: "contact", label: "Kontakt", testId: TESTIDS.navLinkContact },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const goToSection = (id) => {
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
      // small delay for DOM ready
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 60);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="pz-header">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-24 sm:h-28 flex items-center justify-between">
        <Link
          to="/"
          data-testid={TESTIDS.headerLogo}
          className="flex items-center gap-2"
          aria-label="Prozenthaus Startseite"
        >
          <img
            src="/logo.png"
            alt="Prozenthaus – Markenware bis 50 % reduziert"
            width="200"
            height="60"
            fetchPriority="high"
            decoding="async"
            className="pz-logo-img"
            loading="eager"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => goToSection(l.id)}
              data-testid={l.testId}
              className="pz-link text-sm tracking-wide"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={EBAY_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={TESTIDS.headerCtaEbay}
            className="pz-btn pz-btn-primary text-sm hidden sm:inline-flex"
          >
            Zum eBay-Shop <ArrowUpRight size={16} />
          </a>
          <button
            className="md:hidden p-2 border border-[var(--pz-border)] bg-white"
            onClick={() => setOpen((v) => !v)}
            data-testid={TESTIDS.mobileMenuToggle}
            aria-label="Menü öffnen"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[var(--pz-border)] bg-white">
          <div className="px-5 py-4 flex flex-col gap-3">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`${l.testId}-mobile`}
                onClick={() => {
                  goToSection(l.id);
                  setOpen(false);
                }}
                className="text-left text-base font-semibold py-2"
              >
                {l.label}
              </button>
            ))}
            <a
              href={EBAY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="pz-btn pz-btn-primary mt-2 self-start"
            >
              Zum eBay-Shop <ArrowUpRight size={16} />
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
